/* istanbul ignore file */
import React from 'react';
import Cookies from 'js-cookie';
import { styled } from '@mui/material/styles';

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useImTheme } from '@im/im-theme';
import { CulturePicker } from '@im/ui-lib/CulturePicker';

import { LoginButton, useUserInfo } from 'mf_core/auth';

export function DebugToolbar() {
  const { setThemeName, theme } = useImTheme();
  const isDark = theme.palette.mode === 'dark';

  const userInfo = useUserInfo();

  return (
    <Root>
      <div>(Ignore Testing Toolbar)</div>
      <FormControlLabel
        control={
          <Switch
            checked={isDark}
            onChange={() => setThemeName(isDark ? 'im-light' : 'im-dark')}
          />
        }
        label="Dark Mode"
        labelPlacement="start"
      />

      <CulturePicker />

      <div>
        <LoginButton />
      </div>
      <div>{userInfo ? userInfo.name : ' '}</div>

      <FlexGap />

      <FormControlLabel
        control={<Switch checked={true} onChange={() => switchToClassic()} />}
        label="New Look"
        labelPlacement="start"
      />
    </Root>
  );
}

const Root = styled('div')(({ theme }) => {
  return {
    alignItems: 'center',
    background: 'lightgrey',
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    minHeight: theme.spacing(5),
    minWidth: 800,
    paddingLeft: 8,
    paddingRight: 16,
  };
});

const FlexGap = styled('div')(() => {
  return {
    flex: 1,
  };
});

function switchToClassic() {
  Cookies.remove('IMOnline_CEP');
  Cookies.set('IMOnline_Legacy', 'true');
  const { location } = globalThis;
  location.href = origin;
}
